module.exports = __webpack_public_path__ + "static/media/Zealtechbd-logo.913f87d3.png";